// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.artwork-preview-surface {
  --artwork-preview-max-height: 220px;
  align-items: center;
  background-color: #767676;
  border: 1px solid rgba(30, 41, 59, 0.18);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  display: inline-flex;
  justify-content: center;
  max-height: var(--artwork-preview-max-height);
  max-width: 100%;
  overflow: hidden;
  padding: 12px;
}

.artwork-preview-surface__image {
  display: block;
  filter: drop-shadow(0 1px 1px rgba(15, 23, 42, 0.55)) drop-shadow(0 -1px 1px rgba(255, 255, 255, 0.65));
  height: auto;
  max-height: calc(var(--artwork-preview-max-height) - 24px);
  max-width: 100%;
  object-fit: contain;
  width: auto;
}

.artwork-preview-surface--button {
  cursor: zoom-in;
  font: inherit;
}

.artwork-preview-surface--button:focus-visible {
  outline: 3px solid var(--mf-primary-color, #012979);
  outline-offset: 2px;
}

.artwork-preview-with-enlarge {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 20px;
  max-width: 100%;
}

.artwork-preview-enlarge-link {
  padding-bottom: 0;
  padding-top: 4px;
}

.artwork-preview-surface--overlay-option {
  margin-bottom: 10px;
}

.artwork-preview-surface--selected-artwork {
  margin-bottom: 0;
}

.artwork-preview-surface--enlarged {
  display: flex;
  width: 100%;
}

.artwork-preview-surface--proof-preview {
  display: flex;
  margin: 0 auto;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Shop/DigitalProofingForms/ArtworkPreviewSurface.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;EACpB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uGAAuG;EACvG,YAAY;EACZ,0DAA0D;EAC1D,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb","sourcesContent":[".artwork-preview-surface {\n  --artwork-preview-max-height: 220px;\n  align-items: center;\n  background-color: #767676;\n  border: 1px solid rgba(30, 41, 59, 0.18);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n  display: inline-flex;\n  justify-content: center;\n  max-height: var(--artwork-preview-max-height);\n  max-width: 100%;\n  overflow: hidden;\n  padding: 12px;\n}\n\n.artwork-preview-surface__image {\n  display: block;\n  filter: drop-shadow(0 1px 1px rgba(15, 23, 42, 0.55)) drop-shadow(0 -1px 1px rgba(255, 255, 255, 0.65));\n  height: auto;\n  max-height: calc(var(--artwork-preview-max-height) - 24px);\n  max-width: 100%;\n  object-fit: contain;\n  width: auto;\n}\n\n.artwork-preview-surface--button {\n  cursor: zoom-in;\n  font: inherit;\n}\n\n.artwork-preview-surface--button:focus-visible {\n  outline: 3px solid var(--mf-primary-color, #012979);\n  outline-offset: 2px;\n}\n\n.artwork-preview-with-enlarge {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  max-width: 100%;\n}\n\n.artwork-preview-enlarge-link {\n  padding-bottom: 0;\n  padding-top: 4px;\n}\n\n.artwork-preview-surface--overlay-option {\n  margin-bottom: 10px;\n}\n\n.artwork-preview-surface--selected-artwork {\n  margin-bottom: 0;\n}\n\n.artwork-preview-surface--enlarged {\n  display: flex;\n  width: 100%;\n}\n\n.artwork-preview-surface--proof-preview {\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
